import type { SVGProps } from 'react';
const DawnFlagCA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-CA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fill="#FF3131" mask="url(#dawn-flag-CA_svg__a)">
      <path d="M15.714 0H22v16h-6.286z" />
      <path
        fillRule="evenodd"
        d="M0 16h6.286V0H0zM12.827 7.207a.333.333 0 0 1-.565-.298l.31-1.576-1.048.534-.524-1.6-.524 1.6-1.048-.534.31 1.576a.333.333 0 0 1-.565.298l-.03-.032a.333.333 0 0 0-.476 0l-.286.292-1.048-.534L7.857 8l-.295.3a.333.333 0 0 0 0 .467l1.342 1.366h1.572l.262 1.6h.524l.261-1.6h1.572l1.342-1.366a.333.333 0 0 0 0-.467l-.294-.3.523-1.067-1.047.534-.286-.292a.333.333 0 0 0-.476 0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCA;
